import React, { forwardRef, useEffect, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

const WallarmMappingForm = forwardRef(function WallarmMappingForm(props, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { nodeId, nodeName } = props.record;
      return [{id: nodeId, name: nodeName }]
    }
    return [];
  });

    useEffect(() => {
        const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
        promise.then((response) => {
          const { projects } = response;
          setProjects(projects);
        }).catch((err)=>{
          message.error('Problem fetching projects')
        });
        
        return cancel;
    }, [props.loginConfigId, props.toolName]);
  
    const getExtraFieldsData = useCallback((config) => {
      const { nodeId } = config;
      return {
        nodeId,
        nodeName: projects.find(project => project.id === nodeId)?.name
      };
    }, [projects])
  
    const extraFields = useMemo(() => ([{
        name: 'nodeId',
        colSpan: 12,
        type: FieldTypes.SELECT,
        label: 'Node Name',
        options: projects.map(option => {
          const { label = option.name, value = option.id } = option;
          return { label, value }
        }),
        required: true,
        props: {
          autoFocus: true
        }
      }
    ]), [projects]);
    return (
        <GenericMappingForm
          ref={ref}
          {...props}
          projects={projects}
          getExtraFieldsData={getExtraFieldsData}
          extraFields={extraFields}
        />
      )
})

export default WallarmMappingForm;